import { horizontalGap } from '@sunwebgroup/ui-components'
import { repeat } from 'ramda'
import { styled } from 'styled-components'
import { AccoCardLoading } from '../AccoCard/AccoCardLoading'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${horizontalGap('spacing_md')}
`

export function AccoListLoading() {
  return <Wrapper>{repeat(<AccoCardLoading />, 3)}</Wrapper>
}
